export default "__VITE_ASSET__DQAoA83b__"